module.exports = __webpack_public_path__ + "img/pdf.03867d16.svg";